// Basic strength calc: length + variety (lower/upper/num/special)
export function calcPasswordStrength(pwd: string): number {
  let score = 0;
  if (pwd.length >= 8) score++;
  if (/[A-Z]/.test(pwd)) score++;
  if (/[a-z]/.test(pwd)) score++;
  if (/[0-9]/.test(pwd)) score++;
  if (/[^A-Za-z0-9]/.test(pwd)) score++;
  return Math.min(score, 5); // clamp 0..5
}

const LABELS = ["Very weak", "Weak", "Okay", "Good", "Strong", "Strong"] as const;
const COLORS = ["#ef4444", "#f97316", "#f59e0b", "#22c55e", "#16a34a", "#16a34a"] as const;

export function strengthLabel(score: number): string {
  return LABELS[Math.max(0, Math.min(score, 5))];
}
export function strengthColor(score: number): string {
  return COLORS[Math.max(0, Math.min(score, 5))];
}
